<template>
  <div class="w-view-shell">
    <!-- 面包屑  -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>全部课程</el-breadcrumb-item>
      <el-breadcrumb-item class="ke">{{
        play_info.directory_name
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="video-view-shell" v-if="course_type == 1">
      <div class="video-shell">
        <video
          :src="video_src"
          v-if="video_src"
          controls="controls"
          id="myVideo"
          poster="@/assets/video_bg.jpg"
          controlslist="nodownload"
          disablePictureInPicture="true"
          @play="play()"
          @pause="pause"
          preload="preload"
          @ended="ended"
          @error="error"
          @waiting="waiting"
          @ratechange="onratechange"
        >
          对不起，您的浏览器暂不支持video视频标签!
        </video>
        <img :src="course_info.course_img" v-else alt="" />
      </div>
    </div>
    <div class="video-view-shell">
      <!--            普通课程-->
      <template v-if="course_type == 1">
        <div class="bt-hint" v-if="course_info.parent_cate == '药师职称' && course_info.show_konw != 0">
          <div>
            <h3>温馨提示</h3>
            <div>{{course_info.know_year}}年药事管理与法规知识点汇总，<span>请点击</span><div @click="handleOpen">法规知识点</div></div>
          </div>
        </div>
        <template v-if="course_info.course_type == 0">
          <div class="beisu" v-if="video_src">
            <span>倍速：</span>
            <el-select v-model="beisu" placeholder="请选择" @change="beisuChange">
              <el-option label="1" :value="1"></el-option>
              <el-option label="1.25" :value="1.25"></el-option>
              <el-option label="1.5" :value="1.5"></el-option>
            </el-select>
          </div>
          <div
            class="video-list"
            v-for="(item, index) in video_list"
            :key="index"
          >
            <template v-if="item.child_info.length < 1">
              <div class="video-box  video-box2 handler">
                <div class="video-box-left">
                  <div class="item">
                    <div class="video-type"></div>
                    <div
                      class="video-tips"
                      :style="{
                        color: directory_id == item.directory_id ? 'red' : '',
                      }"
                    >
                      {{ item.directory_name }}（{{
                        Math.ceil(item.file_time / 60)
                      }}分钟）
                    </div>
                    <div class="video-time"></div>
                  </div>
                  <div class="rate">
                    <div class="video-type"></div>
                    <span>学习进度：{{ item.learn_rate }}%</span>
                    <el-progress
                      :percentage="item.learn_rate"
                      style="width: 200px"
                      :show-text="false"
                      color="#2AA9B5"
                    ></el-progress>
                  </div>
                </div>
                <div class="video-box-right">
                  <div
                    class="study-status"
                    v-if="directory_id != item.directory_id"
                    @click.stop="cut_play(item)"
                  >
                    <span
                      :style="{ color: item.learn_status == '已学完' && 'red' }"
                    >
                      {{ item.learn_status }}
                    </span>
                  </div>
                  <div class="study-status" @click.stop="go_test(item)" v-if="course_info.parent_cate != 46 && course_info.parent_cate != '药师职称' && course_info.parent_cate != '药师培训'">
                    模拟考题
                  </div>
                  <div
                    class="video-status"
                    v-if="directory_id == item.directory_id"
                  >
                    <img src="@/assets/underway-icon.png" alt="" />进行中
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="video-box video-box2">
                <div class="video-box-left">
                  <div class="video-type"></div>
                  <div
                    class="video-tips"
                    :style="{
                      color: directory_id == item.directory_id ? 'red' : '',
                    }"
                  >
                    {{ item.directory_name }}（{{
                      Math.ceil(item.file_time / 60)
                    }}分钟）
                  </div>
                  <div class="video-time"></div>
                </div>
                <div class="video-box-right"></div>
              </div>
              <div
                class="video-box handler"
                v-for="(item2, index2) in item.child_info"
                :key="item2.directory_id"
              >
                <div class="video-box-left">
                  <div class="item">
                    <div class="video-type">
                      <img
                        src="@/assets/audio_icon.png"
                        alt=""
                        v-if="item2.file_type == 0"
                      />
                      <img src="@/assets/lesson.png" alt="" v-else />
                    </div>
                    <div
                      class="video-tips"
                      :style="{
                        color: directory_id == item.directory_id ? 'red' : '',
                      }"
                    >
                      【录播】{{ item2.directory_name }}（{{
                        Math.ceil(item2.file_time / 60)
                      }}分钟）
                    </div>
                    <div class="video-time"></div>
                  </div>
                  <div class="rate">
                    <div class="video-type"></div>
                    <span>学习进度：{{ item.learn_rate }}%</span>
                    <el-progress
                      :percentage="item.learn_rate"
                      style="width: 200px"
                      :show-text="false"
                      color="#2AA9B5"
                    ></el-progress>
                  </div>
                </div>
                <div class="video-box-right">
                  <div
                    class="study-status"
                    v-if="directory_id != item2.directory_id"
                    @click.stop="cut_play(item)"
                    :style="{ color: item.learn_status == '已学完' && 'red' }"
                  >
                    {{ item2.learn_status }}
                  </div>
                  <div
                    class="study-status"
                    @click.stop="cut_play(item2, index2)"
                    v-else
                  >
                    开始学习
                  </div>
                  <div class="study-status" @click.stop="go_test(item)" v-if="course_info.parent_cate != 46 && course_info.parent_cate != '药师培训'">
                    模拟考题
                  </div>
                  <div
                    class="video-status"
                    v-if="directory_id == item2.directory_id"
                  >
                    <img src="@/assets/underway-icon.png" alt="" />进行中
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
        <div v-else v-html="course_info.oral_desc"></div>
      </template>
      <!--            药师课程-->
      <div class="video-list" v-if="false">
        <div
          class="video-box "
          v-for="(item, index) in video_list"
          :key="index"
          style="margin-bottom: 10px"
        >
          <div class="video-box-left">
            <div class="item">
              <div class="video-type">
                <img
                  src="@/assets/audio_icon.png"
                  alt=""
                  v-if="item.file_type == 0"
                />
                <img src="@/assets/lesson.png" alt="" v-else />
              </div>
              <div
                class="video-tips"
                :style="{
                  color: directory_id == item.directory_id ? 'red' : '',
                }"
              >
                【录播】{{ item.directory_name }}（{{
                  Math.ceil(item.file_time / 60)
                }}分钟）
              </div>
              <div class="video-time"></div>
            </div>
            <div class="rate">
              <div class="video-type" style="margin-right: 0"></div>
              <span>学习进度：{{ item.learn_rate }}%</span>
              <el-progress
                :percentage="item.learn_rate"
                style="width: 200px"
                :show-text="false"
                color="#2AA9B5"
              ></el-progress>
            </div>
          </div>
          <div class="video-box-right handler">
            <div
              class="study-status"
              :style="{ color: item.learn_status == '已学完' && 'red' }"
              v-if="directory_id != item.directory_id"
              @click.stop="cut_play(item)"
            >
              {{ item.learn_status }}
            </div>
            <div class="study-status" @click.stop="go_test(item)">模拟考题</div>
            <div class="video-status" v-if="directory_id == item.directory_id">
              <img src="@/assets/underway-icon.png" alt="" />进行中
            </div>
          </div>
        </div>
      </div>
      <div class="hint" v-if="course_type == 2">
        <div>
          <h3>温馨提示</h3>
          <div>1、课程全部学完，<span style="color: red">请点击=></span><div @click="handleLink">复习资料</div>，以便顺利通过考核。</div>
          <div>2、课程全部学完，请等待省局审核，<span>3-5天后</span>进入<span>药师考核</span>参加考试，<span style="color: red;">考核平台开启期间，每天可考2次，考过为止</span>。</div>
          <div>3、每节课不需要一次看完，<span>中途退出，系统自动保留学习记录。</span></div>
        </div>
        <div>
          <img src="@/assets/APPLoad.jpg" alt="">
          <span>手机APP学习</span>
        </div>
      </div>
      <div class="video-arr" v-if="course_type == 2">
        <div
          class="video-item"
          v-for="(item, index) in video_list"
          :key="index"
        >
          <div>
            <img :src="item.directory_img" alt="">
          </div>
          <div>
            <div class="title">
              <h3>{{item.directory_name}}</h3>
              <!-- <el-tag size="small" :class="item.learn_status == '已学完' ? 'red' : ''">{{item.learn_status}}</el-tag> -->
            </div>
            <span>授课老师：{{item.teacher_name}}</span>
            <span>时长：{{item.file_time | setTime}}分钟</span>
            <div>
              <span>学习进度：{{item.learn_rate}}%</span>
              <el-progress color="#2aa9b5" :percentage="item.learn_rate" :show-text="false" style="width: 200px"></el-progress>
            </div>
          </div>
          <div>
            <!-- <div class="lianxi-btn" @click.stop="go_test(item)">模拟考题</div> -->
            <div class="xuexi-btn" @click.stop="cut_play(item, index)">{{item.learn_status}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--        视频抓拍-->
    <div
      class="video-photo-shell"
      v-show="photo_show"
      @click.stop="stopNavigator"
    >
      <div class="camera_outer" @click.stop="">
        <div class="title" v-if="photo_type == 1">人脸识别</div>
        <div class="title" v-if="photo_type == 2">视频抓拍</div>
        <div class="title" v-if="photo_type == 3">上传头像</div>
        <div class="photo-tips" v-if="photo_type == 1 || photo_type == 2">
          <span>人脸识别提示：</span>
        </div>
        <div class="photo-tips" style="text-indent: 40px;" v-if="photo_type == 1 || photo_type == 2">
          <span>根据湖南省药监局要求，</span>
          系统将通过
          <span>人脸识别及随机抓拍</span>
          监管学习过程，
          <span>严防代学、挂机刷课</span>
          。请确保摄像头对准本人，严禁使用照片等非本人方式，否则省局将
          <span>判定作弊，课程全部重学。</span>
        </div>
        <div class="photo-tips" v-if="photo_type == 3">
          温馨提示：您还未上传头像,请上传本人真实照片,用于后续进行人脸识别!
        </div>
        <div
          class="submit-photo-btn"
          @click.stop="first_up_img()"
          v-if="photo_type == 1"
        >
          点击识别
        </div>
        <!--                <div class="submit-photo-btn" @click.stop="setImage()" v-if="photo_type==2">点击抓拍</div>-->
        <div
          class="submit-photo-btn"
          @click.stop="up_user_img()"
          v-if="photo_type == 3"
        >
          点击拍照
        </div>
        <video
          id="videoCamera"
          :width="videoWidth"
          :height="videoHeight"
          autoplay
        ></video>
        <canvas
          style="display:none;"
          id="canvasCamera"
          :width="videoWidth"
          :height="videoHeight"
        ></canvas>
        <div class="photo_down_time" v-if="photo_down_time > 0">
          {{ photo_down_time }}
        </div>
      </div>
    </div>
    <div
      class="video-photo-shell"
      v-show="applet_show"
      @click.stop="applet_show = false"
    >
      <div class="camera_outer">
        <div class="title">
          电脑需安装或自带摄像头， 若没有, 您可以扫码关注公众号进行学习
        </div>
        <img src="@/assets/gzh.jpg" alt="" class="applet-img" />
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="30%" center>
      <div class="success">
        <h3>专属老师微信</h3>
        <p>快扫码添加你的专属老师微信</p>
        <img src="@/assets/teacher_wx.png" alt="" class="code" />
        <div>服务时间：周一至周五8:30～17；30</div>
      </div>
      <span slot="footer"></span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Coursetobuy",
  data() {
    return {
      photo_down_time: -1,
      applet_show: false,
      course_id: 0,
      course_info: {},
      video_list: [],
      play_info: {
        directory_name: "视频学习",
        file_url: "",
      },
      is_finish: 0,
      photo_time: [],
      directory_id: 0,
      course_type: 1, // 区分普通课程和药师课程
      study_time: 0,
      start_study_time: 0,
      end_time: 0,
      start_time: 0,
      play_time: 0,
      current_play_time: 0,
      img_url: "",
      video_src: "",
      photo_timer: 3,
      // 抓拍
      videoWidth: 430,
      videoHeight: 320,
      imgSrc: "",
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      openVideo: false,
      photo_show: false,
      allow_photo: true,
      free_tips: true,
      video_timer: null,
      is_photo: true,
      allow_play: false,
      allow_camera: false,
      user_info: "",
      photo_type: 1, // 1 第一次拍照 2 后续拍照 3 未上传头像
      old_play_time: 0,
      handle_allow: true,
      finished: false,
      player: null,
      dialogVisible: false,
      beisu: 1,
    };
  },
  filters: {
    setTime (time) {
      return Math.round(time/60)
    }
  },
  created() {
    if (this.$route.query.course_type == 2) {
      this.API.post("user/course_in-get_course_year", {course_id:this.$route.query.course_id}).then(res => {
        const h = this.$createElement;
        this.$msgbox({
          title: '重要提示',
          message: h('p', { style: 'width: 315px' }, [
            h('span', null, '按省药监局统一要求，以'),
            h('span', { style: 'color: red' }, '相片'),
            h('span', null, '及其他非正常方式“人脸识别”省局审核判定“'),
            h('span', { style: 'color: red' }, '作弊'),
            h('span', null, '”，所学课程'),
            h('span', { style: 'color: red' }, '全部清除重学'),
            h('span', null, '。'),
            res.data == 2026 && h('p', { style: 'color: red;text-align: left;background-color: yellow;width: fit-content' }, '学习考核：8月31日截止！'),
          ]),
          confirmButtonText: '知道了',
          center: true,
        });
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      let openNum = Number(localStorage.getItem('openNum')) || 0
      if (openNum != 2) {
        openNum++
        localStorage.setItem('openNum', openNum)
        this.dialogVisible = true
      }
    })

    this.$nextTick(() => {
      const a_link = document.createElement("a")
      document.body.appendChild(a_link);
      a_link.click();
    })
    this.course_id = this.$route.query.course_id;
    if (this.$route.query.directory_id) {
      this.directory_id = this.$route.query.directory_id;
      this.get_play_info();
      this.API.post("Home/course_out-get_course_info", {
        course_id: this.course_id,
      }).then((res) => {
        if (res.errno != 0) {
          return;
        }
        this.course_info = res.data.course_info;
        this.video_list = res.data.course_info.dir_info;
      });
    } else {
      if (this.$route.query.course_type) {
        this.course_type = this.$route.query.course_type;
      }
      if (this.course_type != 2) {
        this.get_course_info();
      } else {
        this.get_phar_info();
      }
    }
    this.handle_allow = true;
    this.getUserInfo();
  },
  activated () {
    if (this.player) {
      this.player.pause()
      this.player = null
    }
  },
  destroyed() {
    if (this.player) {
      this.player.pause()
      this.player = null
    }
    this.up_study_log();
    window.clearInterval(this.timer_log);
    window.clearInterval(this.video_timer);
  },
  methods: {
    getUserInfo() {
      this.API.post("user/user_infos-user_info", {}).then((res) => {
        this.user_info = res.data.user_info;
        this.$emit("get-info");
      });
    },
    up_user_img() {
      let _this = this;
      if (!_this.allow_camera) {
        return;
      }
      // canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      );
      // 获取图片base64链接
      let video = document.getElementById("myVideo");
      if (video) {
        video.pause();
      }
      let image = _this.thisCancas.toDataURL("image/png");
      _this.dealImage(image, 600, function(base64) {
        image = base64;
        let fd = new FormData();
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", image);
        _this.API.post("user/user_infos-upload_img", fd).then((r) => {
          _this.API.post("user/user_infos-edit_user", {
            head_img: r.data.file_path,
            sex: _this.user_info.sex ? _this.user_info.sex : 1,
            nick_name: _this.user_info.nick_name,
            company_id: _this.user_info.company_id || 0,
          }).then((res) => {
            _this.stopNavigator();
            _this.photo_type = 1;
            _this.API.SMessage("头像上传成功");
            _this.getUserInfo();
          });
        });
      });
    },
    go_test(item, index) {
      this.$router.push({
        path:
          "/contact?course_id=" +
          this.course_id +
          "&course_type=" +
          this.course_type +
          "&directory_id=" +
          item.directory_id +
          "&=timestamp" +
          new Date().getTime(),
      });
    },
    first_up_img() {
      if (!this.handle_allow) {
        return this.API.SMessage("操作过于频繁");
      }
      this.handle_allow = false;
      setTimeout(() => {
        this.handle_allow = true;
      }, 2000);
      let _this = this;
      if (!_this.allow_camera) {
        return;
      }
      // canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      );
      // 获取图片base64链接
      let video = document.getElementById("myVideo");
      video.pause();
      let image = _this.thisCancas.toDataURL("image/png");
      _this.dealImage(image, 600, function(base64) {
        image = base64;
        let fd = new FormData();
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", image);
        _this.API.post("user/user_infos-upload_img", fd).then((res2) => {
          _this.API.post("user/course_in-snapshot", {
            img_url: res2.data.file_path,
          }).then((res) => {
            if (res.errno == 0) {
              video.play();
              _this.API.SMessage("验证成功");
              _this.stopNavigator();
              _this.allow_play = true;
              _this.photo_type = 2;
            } else {
              _this.allow_play = false;
              _this
                .$confirm(res.message + ",请确定是本人后重试?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                .then(() => {
                  // _this.first_up_img()
                })
                .catch(() => {
                  _this.stopNavigator();
                });
            }
          });
        });
      });
    },
    dealImage(base64, w, callback) {
      var newImage = new Image();
      var quality = 0.8; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function() {
        imgWidth = this.width;
        imgHeight = this.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            canvas.height = (w * imgHeight) / imgWidth;
          } else {
            canvas.height = w;
            canvas.width = (w * imgWidth) / imgHeight;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
          quality = 0.6;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        callback(base64);
      };
    },
    beisuChange () {
      let video = document.getElementById("myVideo");
      video.playbackRate = this.beisu
    },
    video_uptime(time) {
      let _this = this;
      let video = document.getElementById("myVideo");
      let currentTime = time;
      let dif = Math.abs(this.old_play_time - currentTime);
      if (dif > 1.5 && _this.is_finish != 1) {
        if (_this.play_info.is_record == 0) {
        } else if (_this.play_info.is_record == 1) {
          video.currentTime = _this.old_play_time;
          _this.API.SMessage("未学习完课程,请不要快进后退");
        } else if (_this.play_info.course_info.is_record == 0) {
          _this.current_play_time = time;
        } else {
          video.currentTime = _this.old_play_time;
          _this.API.SMessage("未学习完课程,请不要快进后退");
        }
      } else {
        _this.current_play_time = parseInt(time);
        this.old_play_time = time;
      }
    },
    onratechange () {
      if (this.course_type != 1) {
        if (this.course_info.course_type == 0) {
          let video = document.getElementById("myVideo");
          video.playbackRate = 1
        }
      }
    },
    play() {
      let video = document.getElementById("myVideo");
      if (
        (!this.allow_play && this.play_info.is_photo) ||
        (!this.allow_play && this.play_info.course_info.is_photo)
      ) {
        // if (!this.allow_play) {
        video.pause();
        this.getCompetence();
        if (this.photo_type == 2) {
          this.photo_down_time = 5;
          if (this.player) {
            this.player.pause();
            this.player = null
          }
          const a_link = document.createElement("a")
          document.body.appendChild(a_link);
          a_link.click();
          this.$nextTick(() => {
            this.player = new Audio("https://video.xyyysp.com/54321.mp3");
            this.player.loop = 'loop'
            this.player.play();
          })
          let timer = setInterval(() => {
            if (this.photo_down_time == 0) {
              if (this.player) {
                this.player.pause()
                this.player = null
              }
              clearInterval(timer);
              this.setImage();
            } else {
              this.photo_down_time--;
            }
          }, 1000);
        }
      }
      let _this = this;
      _this.free_tips = true;
    },
    pause() {
      window.clearInterval(this.video_timer);
      this.up_study_log();
    },
    ended() {
      this.up_study_log();
      window.clearInterval(this.video_timer);
    },
    error() {
      // this.API.SMessage('视频播放出错,请手动进行刷新,再点击播放!')
      window.clearInterval(this.video_timer);
    },
    waiting() {
      // this.API.SMessage('网络不稳定,您可以点击暂停待视频缓冲后再进行播放')
    },
    round_photo_up() {
      let _this = this;
      let video = document.getElementById("myVideo");
      video.pause();
      _this.allow_photo = true;
      _this.dealImage(_this.imgSrc, 600, function(base64) {
        _this.imgSrc = base64;
        let fd = new FormData();
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", _this.imgSrc);
        _this.API.post("user/user_infos-upload_img", fd).then((res2) => {
          _this.API.post("user/course_in-photo_in", {
            directory_id: _this.directory_id,
            course_id: _this.course_id,
            img_url: res2.data.file_path,
            course_type: _this.course_type,
          }).then((res) => {
            _this.finished = false
            if (res.errno == 0) {
              video.play();
              _this.allow_play = true;
              _this.stopNavigator();
              _this.API.SMessage("验证成功");
              setTimeout(() => {
                _this.allow_photo = true;
                _this.is_photo = true;
              }, 3000);
            } else {
              _this.allow_play = false;
              _this
                .$confirm("视频抓拍失败，重新抓拍？", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  center: true,
                })
                .then(() => {
                  _this.photo_down_time = 5;
                  if (_this.player) {
                    _this.player.pause();
                    _this.player = null
                  }
                  const a_link = document.createElement("a")
                  document.body.appendChild(a_link);
                  a_link.click();
                  _this.$nextTick(() => {
                    _this.player = new Audio("https://video.xyyysp.com/54321.mp3");
                    _this.player.loop = 'loop'
                    _this.player.play();
                  })
                  let timer = setInterval(() => {
                    if (_this.photo_down_time == 0) {
                      if (_this.player) {
                        _this.player.pause()
                        _this.player = null
                      }
                      clearInterval(timer);
                      _this.setImage();
                    } else {
                      _this.photo_down_time--;
                    }
                  }, 1000);
                })
                .catch(() => {
                  _this.stopNavigator();
                });
            }
          });
        });
      });
    },
    cut_play(item, index) {
      if (this.course_type == 2) {
        if (item.learn_status == '开始学习') {
          this.$alert('按省局统一要求，课程学完后请完成“课程评价”，方可通过省局审核！', '重要提示', {
            confirmButtonText: '知道了',
            closeOnPressEscape: false,
            center: true,
            roundButton: true,
            confirmButtonClass: 'alertBtn',
            customClass: 'alertFont',
            callback: action => {
              console.log(action)
              if (action == 'confirm') {
                this.$router.push({path: '/GostudyList', query: {course_type: this.course_type, course_id: this.course_id, index: index}})
              }
            }
          });
          return;
        }
        this.$router.push({path: '/GostudyList', query: {course_type: this.course_type, course_id: this.course_id, index: index}})
        return;
      }
      let video = document.getElementById("myVideo");
      if (video) {
        video.currentTime = 0;
      }
      this.old_play_time = 0;
      this.API.post2("user/user_infos-thumb_status", {}).then((res) => {
        if (res.errno == 0) {
          if (res.data.thumb_status || this.course_info.is_photo == 0) {
            this.photo_type = 1;
            this.allow_play = false;
            window.clearInterval(this.timer_log);
            this.video_src = "";
            this.directory_id = item.directory_id;
            this.course_info.course_name = item.directory_name;
            if (this.course_type != 1) {
              this.get_phar_play(1);
            } else {
              this.get_play_info(1);
            }
          } else {
            this.photo_type = 3;
            this.getCompetence();
          }
        } else {
          this.API.SMessage(res.message);
        }
      });
    },
    get_course_info() {
      this.API.post("Home/course_out-get_course_info", {
        course_id: this.course_id,
      }).then((res) => {
        if (res.errno != 0) {
          return;
        }
        this.course_info = res.data.course_info;
        this.video_list = res.data.course_info.dir_info;
        // this.directory_id = res.data.dir_id
        // if (!this.directory_id) {
        // return
        // }
        // if (this.course_type != 1) {
        //   this.get_phar_play()
        // } else {
        //   this.get_play_info()
        // }
      });
    },
    get_phar_info() {
      // 药师课程列表
      this.API.post("user/phar_in-phar_course_info", {
        course_id: this.course_id,
      }).then((res) => {
        if (res.errno != 0) {
          return;
        }
        let course_list = res.data.course_list
        course_list.forEach(e => {
          if (e.is_finish == 1 && e.is_comment == 0) {
            e.learn_rate = 99.99
            e.learn_status = '继续学习'
          }
        });
        this.video_list = course_list;
        let info = localStorage.getItem("user_info")
        this.course_info = {
          course_img: this.video_list[0].course_img,
          cate_name: JSON.parse(info).leixing,
          cnt_course: res.data.cnt_num,
          pdf_link: res.data.pdf_link,
          is_photo: res.data.course_info ? res.data.course_info.is_photo : 1,
        };
        // this.directory_id = res.data.dir_id
        // if (!this.directory_id) {
        //   return
        // }
        // if (this.course_type != 1) {
        //   this.get_phar_play()
        // } else {
        //   this.get_play_info()
        // }
      });
    },
    get_play_info(type = "") {
      //播放地址
      this.API.post("Home/course_out-get_play_info", {
        directory_id: this.directory_id,
      }).then((res) => {
        if (res.errno != 0) {
          if (res.code == 2078) {
            this.photo_type = 3;
            this.getCompetence();
          }
          return;
        }
        this.play_info = res.data.play_info;
        this.play_info.play_time = Number(this.play_info.play_time)
        if (this.play_info.play_time > this.play_info.file_time) {
          this.play_info.play_time = this.play_info.file_time
        }
        this.video_src = this.play_info.file_url;
        this.record_id = this.play_info.record_id;
        this.is_finish = this.play_info.is_finish;
        this.play_time = this.play_info.play_time;
        this.start_time = this.play_info.play_time;
        this.photo_time = this.play_info.course_info.photo_time
          ? this.play_info.course_info.photo_time
          : [];
        setTimeout(() => {
          let _this = this;
          let video = document.getElementById("myVideo");
          video.play();
          video.currentTime = _this.play_time;
          _this.old_play_time = _this.play_info.play_time;
          _this.current_play_time = _this.play_time;
          video.addEventListener("timeupdate", function() {
            let timeDisplay;
            timeDisplay = Math.ceil(video.currentTime);
            _this.video_uptime(video.currentTime);
            // 抓拍
            if (_this.photo_time.length > 0) {
              if (
                _this.photo_time.indexOf(timeDisplay) != -1 &&
                _this.allow_photo &&
                _this.is_photo
              ) {
                _this.allow_play = false;
                _this.is_photo = false;
                _this.allow_photo = false;
                video.pause();
                _this.getCompetence();
                _this.photo_down_time = 5;
                if (_this.player) {
                  _this.player.pause();
                  _this.player = null
                }
                const a_link = document.createElement("a")
                document.body.appendChild(a_link);
                a_link.click();
                _this.$nextTick(() => {
                  _this.player = new Audio("https://video.xyyysp.com/54321.mp3");
                  _this.player.loop = 'loop'
                  _this.player.play();
                })
                let timer = setInterval(() => {
                  if (_this.photo_down_time == 0) {
                    if (_this.player) {
                      _this.player.pause()
                      _this.player = null
                    }
                    clearInterval(timer);
                    _this.setImage();
                  } else {
                    _this.photo_down_time--;
                  }
                }, 1000);
              } else {
              }
            }
            // 试看结束
            if (
              timeDisplay >= _this.play_info.free_time &&
              !_this.play_info.buy_status &&
              _this.free_tips
            ) {
              _this.free_tips = false;
              video.pause();
              video.currentTime = _this.play_info.free_time;
              _this.API.SMessage("免费观看时间结束,请先购买课程");
            }
          });
        }, 800);
        this.timer_log = setInterval(() => {
          let video = document.getElementById("myVideo");
          if (!video.paused && !this.is_finish) {
            this.up_study_log();
          }
          if (this.is_finish) {
            clearInterval(this.timer_log);
          }
        }, 1000 * 6);
      });
    },
    get_phar_play(type = "") {
      // 药师课程播放地址
      let _this = this;
      this.API.post("user/phar_in-phar_play", {
        directory_id: this.directory_id,
      }).then((res) => {
        if (res.errno != 0) {
          if (res.code == 2078) {
            this.photo_type = 3;
            this.getCompetence();
          }
          return;
        }
        this.play_info = res.data.play_info;
        this.video_src = this.play_info.file_url;
        this.record_id = this.play_info.record_id;
        this.is_finish = this.play_info.is_finish;
        this.play_time = this.play_info.play_time;
        this.start_time = this.play_info.play_time;
        this.photo_time = res.data.play_info.photo_time
          ? res.data.play_info.photo_time
          : [];
        if (this.play_info.is_photo && type) {
          // 第一次抓拍
          _this
            .$confirm(
              "播放视频前请确保您已上传真实头像,并且设备有摄像头且已打开!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
              }
            )
            .then((r) => {
              _this.getCompetence();
            })
            .catch((r) => {});
        }
        setTimeout(() => {
          let _this = this;
          let video = document.getElementById("myVideo");
          video.currentTime = _this.play_time;
          _this.old_play_time = _this.play_info.play_time;
          _this.current_play_time = _this.play_time;
          video.addEventListener("timeupdate", function() {
            let timeDisplay;
            timeDisplay = Math.ceil(video.currentTime);
            _this.video_uptime(video.currentTime);
            // 抓拍
            if (_this.photo_time.length > 0) {
              if (
                _this.photo_time.indexOf(timeDisplay) != -1 &&
                _this.allow_photo &&
                _this.is_photo
              ) {
                _this.allow_play = false;
                _this.is_photo = false;
                _this.allow_photo = false;
                video.pause();
                _this.getCompetence();
                _this.photo_down_time = 5;
                let timer = setInterval(() => {
                  if (_this.photo_down_time == 0) {
                    clearInterval(timer);
                    _this.setImage();
                  } else {
                    _this.photo_down_time--;
                  }
                }, 1000);
              } else {
              }
            }
            // 试看结束
            if (
              timeDisplay >= _this.play_info.free_time &&
              !_this.play_info.buy_status &&
              _this.free_tips
            ) {
              _this.free_tips = false;
              video.pause();
              video.currentTime = _this.play_info.free_time;
              _this.API.SMessage("免费观看时间结束,请先购买课程");
            }
          });
        }, 800);
        let video = document.getElementById("myVideo");
        this.timer_log = setInterval(() => {
          if (!video.paused && !this.is_finish) {
            this.up_study_log();
          }
          if (this.is_finish) {
            clearInterval(this.timer_log);
          }
        }, 1000 * 6);
      });
    },
    up_study_log() {
      // 上传学习记录
      if (this.is_finish == 1) {
        return;
      }
      if (this.play_info.is_record && this.play_info.is_record == 0) {
        this.API.post2("user/course_in-learn_finsh", {
          directory_id: this.directory_id,
          course_id: this.course_id,
          course_type: this.course_type,
          play_time: this.current_play_time,
        }).then((res) => {
          console.log(res);
        });
        return;
      } else if (this.play_info.is_record && this.play_info.is_record == 1) {
      } else if (
        this.play_info.course_info &&
        this.play_info.course_info.is_record == 0
      ) {
        this.API.post2("user/course_in-learn_finsh", {
          directory_id: this.directory_id,
          course_id: this.course_id,
          course_type: this.course_type,
          play_time: this.current_play_time,
        }).then((res) => {
          console.log(res);
        });
        return;
      }
      if (this.current_play_time - this.start_time == 0) {
        return;
      }
      this.API.post2("user/course_in-learn_in", {
        directory_id: this.directory_id,
        course_id: this.course_id,
        course_type: this.course_type,
        start_time: this.start_time,
        end_time: this.current_play_time,
        start_study_time: this.start_time,
        study_time: this.current_play_time - this.start_time,
        record_id: this.record_id,
        play_time: this.current_play_time,
      }).then((res) => {
        if (res.code == 2081) {
          this.is_finish = 1;
          window.clearInterval(this.timer_log);
        }
      });
    },
    // 调用权限（打开摄像头功能）https
    getCompetence() {
      window.clearInterval(this.video_timer);
      this.photo_show = true;
      this.allow_play = false;
      let _this = this;
      _this.thisCancas = document.getElementById("canvasCamera");
      _this.thisContext = this.thisCancas.getContext("2d");
      _this.thisVideo = document.getElementById("videoCamera");
      _this.thisVideo.style.display = "block";
      // 获取媒体属性，旧版本浏览器可能不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia;
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            //不存在则报错
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      var constraints = {
        audio: false,
        video: {
          width: this.videoWidth,
          height: this.videoHeight,
          transform: "scaleX(-1)",
        },
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function(stream) {
          // 摄像头可以正常使用
          _this.allow_camera = true;
          // 旧的浏览器可能没有srcObject
          if ("srcObject" in _this.thisVideo) {
            _this.thisVideo.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream);
          }
          _this.thisVideo.onloadedmetadata = function(e) {
            _this.thisVideo.play();
          };
        })
        .catch((err) => {
          _this.allow_camera = false;
          _this.photo_show = false;
          _this.applet_show = true;
          // _this.$alert('摄像头开启失败,请确定您已在设置打开摄像头,并且已允许本网站使用您的摄像头!', '提示', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //   }
          // })
        });
    },
    //  绘制图片（拍照功能）
    setImage() {
      if (this.allow_camera) {
        if (!this.finished) {
          this.finished = true
          let _this = this;
          // canvas画图
          _this.thisContext.drawImage(
            _this.thisVideo,
            0,
            0,
            _this.videoWidth,
            _this.videoHeight
          );
          // 获取图片base64链接
          let image = this.thisCancas.toDataURL("image/png");
          _this.imgSrc = image; //赋值并预览图片
          _this.round_photo_up();
        }
      }
    },
    // 关闭摄像头
    stopNavigator() {
      if (this.player) {
        this.player.pause()
        this.player = null
      }
      this.thisVideo.srcObject.getTracks()[0].stop();
      setTimeout(() => {
        this.photo_show = false;
      }, 10);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    handleLink () {
      console.log(this.course_info.pdf_link)
      window.open(this.course_info.pdf_link)
    },
    handleOpen () {
      window.open('https://video.xyyysp.com/fghz22.pdf')
    }
  },
};
</script>

<style lang="less" scoped>
.video-view-shell {
  margin-bottom: 40px;

  .video-shell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    background-color: #f8f8f8;
    margin-bottom: 30px;

    video {
      width: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }

  .video-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    width: 1200px;
    height: 162px;
    background-color: #fff;
    border-bottom: 1px solid #e5e5e5;

    .video-info-left {
      .video-name {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 42px;
      }

      .video-time {
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-top: 30px;
      }
    }

    .test-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 60px;
      border: 1px solid #2aa9b5;
      border-radius: 8px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2aa9b5;
    }
  }

  .video-list {
    background-color: #fff;
    padding: 10px 0 10px;

    .video-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      width: 90%;
      background: #f4f4f4;
      border-radius: 5px;
      padding: 15px 0;

      .video-box-left {
        .item {
          display: flex;
          align-items: center;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
        .rate {
          display: flex;
          align-items: center;
          margin-top: 10px;
          > span {
            margin-right: 20px;
            font-weight: normal;
          }
        }
      }

      .video-type {
        margin: 0 23px 0 25px;

        img {
          width: 29px;
          height: 28px;
        }
      }

      .video-box-right {
        display: flex;
      }

      .video-status {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2aa9b5;
        margin-right: 37px;

        img {
          width: 21px;
          height: 21px;
          margin-right: 16px;
        }
      }

      .study-status {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2aa9b5;
        margin-right: 37px;
      }
    }

    .video-box2 {
      .video-box-left {
        font-weight: 600;
      }
    }
  }
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}

.el-breadcrumb {
  height: 47px;
  line-height: 47px;
}

.free {
  margin-bottom: 20px;
}

.description {
  margin-bottom: 30px;

  .van-cell {
    height: 162px;

    .title {
      min-width: 276px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #343434;
      line-height: 42px;
    }

    .period {
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      line-height: 60px;
    }

    .Btn {
      height: 60px;
      border: 1px solid #2aaab6;
      border-radius: 8px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2baab5;
    }
  }

  .box {
    width: 1180px;
    min-height: 70px;
    background: #f4f4f4;
    border-radius: 5px;
    line-height: 70px;
    margin-left: 20px;
    margin-bottom: 10px;

    img {
      position: relative;
      top: 5px;
      width: 29px;
      height: 28px;
      margin-left: 24px;
    }

    .span1 {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      margin-left: 15px;
    }

    .span2 {
      float: right;
      margin-right: 38px;
      width: 74px;
      height: 17px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2baab5;
    }
  }
}

.video-photo-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99;

  .applet-img {
    width: 300px;
    height: 300px;
    margin: 20px auto;
  }

  .camera_outer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 610px;
    padding: 20px 0;
    background-color: #fff;
    border: 1px solid #ccc;
    position: relative;

    .photo_down_time {
      position: absolute;
      top: 66%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: red;
      font-weight: 600;
      font-size: 80px;
    }

    .title {
      width: 100%;
      font-weight: 600;
      height: 60px;
      border-bottom: 1px solid #eee;
      font-size: 20px;
      padding: 0 30px;
    }

    .photo-tips {
      width: 100%;
      height: 50px;
      padding: 0 30px;
      color: red;
      font-size: 20px;
      line-height: 30px;
      span {
        font-size: 20px;
        white-space: nowrap;
        font-weight: bold;
      }
    }

    .submit-photo-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      height: 50px;
      width: 40%;
      color: #fff;
      background-color: rgb(0, 98, 204);
      margin: 20px auto;
      cursor: pointer;
    }
  }

  .img_bg_camera {
    width: 100%;
  }

  .tx_img {
    width: 300px;
    height: 300px;
    margin: 0 auto;
  }
}

.hint {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  align-items: center;
  > div {
    display: flex;
    flex-direction: column;
    h3 {
      font-size: 26px;
      margin-bottom: 10px;
    }
    > div {
      display: flex;
      align-items: center;
      font-size: 20px;
      margin-bottom: 15px;
      > div {
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        background-color: #2aa9b5;
        color: #fff;
        margin: 0 10px;
        cursor: pointer;
      }
      span {
        font-size: 20px;
      }
    }
  }
  > div:last-child {
    justify-content: center;
    align-items: center;
    img {
      width: 120px;
      margin-bottom: 15px;
    }
  }
}

.bt-hint {
  margin: 20px 0;
  > div {
    width: 90%;
    margin: 0 auto;
    h3 {
      font-size: 26px;
      margin-bottom: 10px;
      color: red;
    }
    > div {
      display: flex;
      align-items: center;
      font-size: 20px;
      margin-bottom: 15px;
      > div {
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        background-color: #2aa9b5;
        color: #fff;
        margin: 0 10px;
        cursor: pointer;
        letter-spacing: 3px;
      }
      span {
        font-size: 20px;
        font-weight: bold;
        color: red;
      }
    }
  }
}

.beisu {
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 40px;
}

.video-arr {
  background-color: #fff;
  padding: 10px 0;
  .video-item {
    display: flex;
    padding: 15px;
    border-bottom: 1px solid #e3e3e3;
    > div:first-child {
      border: 2px solid #2aa9b5;
      width: 200px;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    > div:nth-child(2) {
      flex: 1;
      margin: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        display: flex;
        align-items: center;
        h3 {
          font-size: 1.2em;
          margin-right: 10px;
        }
      } 
      > span {
        color: #999999;
      }
      > div:last-child {
        display: flex;
        align-items: center;
        span {
          margin-right: 15px;
        }
      }
    }
    > div:last-child {
      display: flex;
      align-items: flex-end;
      > div {
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
        color: #fff;
        &:hover {
          background-color: #37c9d6;
        }
      }
      .lianxi-btn {
        border: 1px solid #2baab5;
        color: #2baab5;
        background-color: #fff;
        &:hover {
          background-color: #37c9d6;
          color: #fff;
        }
      }
      .xuexi-btn {
        border: 1px solid #2baab5;
        background-color: #2baab5;
      }
    }
  }
}

.success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h3 {
    margin: 25px 0;
    font-size: 24px;
  }
  p {
    color: #666666;
    margin-bottom: 25px;
    font-size: 18px;
    text-align: center;
  }
  .code {
    width: 180px;
    margin: 0 0 40px;
  }
}
</style>
